import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { environment } from 'environments/environment';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() toggleMenuSidebar: EventEmitter<any> = new EventEmitter();

  public env = environment.forntend_url;
  public loggedUsername: string;
  public userDetails: Record<any, any> = null;

  constructor(public authService: AuthService) {
    const logInUserInfo = authService.userData;

    if (logInUserInfo['data'] && logInUserInfo['data']?.['name']) {
      this.userDetails = logInUserInfo['data'];
      this.loggedUsername = logInUserInfo['data']['name'];
    }
  }

  isScrolled = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled = window.scrollY > 0;
  }

  ngOnInit(): void { }

  /**
   * @name Logout
   * @description This method is used to logout
   * @param none
   * @return none
   */

  Logout() {
    localStorage.clear();
    window.location.reload();
  }
}
